module.exports = __webpack_public_path__ + "img/linux.e52bde54.svg";